import { LookupSource, createEntireLoadLookupSource } from '@/components';
import { RtkqSpin, useLazyGetReportingClientListQuery } from '@/redux';
import { useMemo } from 'react';
import { mapClientLookup } from '../Clients.Common';

export function useReportingClientLookupSource(
  ids: string[] | null,
): LookupSource {
  const [fetchList] = useLazyGetReportingClientListQuery();

  return useMemo(() => {
    const entireSource = createEntireLoadLookupSource({
      initial: (id: string) =>
        fetchList({ ids, [RtkqSpin]: false }, true)
          .unwrap()
          .then((values) => mapClientLookup(values.find((x) => x.id === id)!)),
      load: () =>
        fetchList({ ids, [RtkqSpin]: false }, true)
          .unwrap()
          .then((values) => values.map((x) => mapClientLookup(x))),
    });

    return { ...entireSource, searchField: '_search' };
  }, [fetchList, ids]);
}
